import { SkeletonChart } from '@/components/shared/SkeletonChart'
import { SkeletonTable } from '@/components/shared/SkeletonTable'
import { Layout, SkeletonPage } from '@shopify/polaris'
import i18next from 'i18next'

const CampaignsFallback = () => {
  return (
    <SkeletonPage title={i18next.t('campaignsTitle')} primaryAction>
      <Layout>
        <Layout.Section>
          <SkeletonChart />
        </Layout.Section>
        <Layout.Section>
          <SkeletonTable />
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  )
}

export { CampaignsFallback }
